module.exports = __webpack_public_path__ + "img/q30-3.467ab9df.jpg";